import React from 'react';
import { Pagination as AntPagination, Icon } from '../../common/UIComponents';

function itemRender(current, type, originalElement) {
  if (type === 'jump-prev') {
    return <span><Icon type="step-backward" /></span>;
  } else if (type === 'jump-next') {
    return <span><Icon type="step-forward" /></span>;
  }
  return originalElement;
}

const GridPagination = (props) => (
  <AntPagination
    {...props}
    itemRender={itemRender}
  />
);

export default GridPagination;